import { render } from "./uploadPreuve.vue?vue&type=template&id=33904655&scoped=true"
import script from "./uploadPreuve.vue?vue&type=script&lang=js"
export * from "./uploadPreuve.vue?vue&type=script&lang=js"

import "./uploadPreuve.vue?vue&type=style&index=0&id=33904655&lang=scss&scoped=true"

import exportComponent from "/usr/src/test-oho-sales/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-33904655"]])

export default __exports__